import { Endpoint } from '@business/api/endpoint';
import { initBlocs } from '@business/blocs';
import { registerBlocs } from '@business/blocs/register';
import { AppConfig } from '@core/utils/config';
import { R } from '@core/utils/r';
import { ignoreError } from '@core/utils/rxjs/operators';
import { Session } from '@modules/auth/session';
import React from 'react';
import { render } from 'react-dom';
import { finalize, tap } from 'rxjs/operators';
import App from './App';

export function boot() {
  registerBlocs();

  initializeAppId();

  restoreSession();
}

function renderApp() {
  const root = document.getElementById('root');
  render(<App />, root);
}

function restoreSession() {
  Session.restore().pipe(tap(initBlocs), ignoreError(), finalize(renderApp)).subscribe();
}

export function initializeAppId() {
  let appId = document.querySelector("meta[name='tenant']")!.getAttribute('content');
  const config = AppConfig.get();
  if (R.isEmpty(appId)) {
    appId = config.appId || '';
  }
  AppConfig.set({ appId });
  Endpoint.setAppId(appId);
  Endpoint.setCompanyId(config.companyId);
}
